import moment from "moment";

export function isValidUuidV4(uuid) {
    return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(uuid);
}

export function daysLeft(from, to) {
    const fromDate = moment(from);
    const toDate = moment(to);
    return toDate.diff(fromDate, "days");
}

export function getCurrentDateTime() {
    return moment().format("YYYY-MM-DD HH:mm:ss");
}

export function getCurrentDateTimeUtc() {
    return moment().utc().format("YYYY-MM-DD HH:mm:ss");
}
